import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { sendOtp, verifyOtp, registerUser } from "../redux/authSlice";
import Footer from "../../../components/Footer/Footer";
import "../styles/AuthLoginPage.css";
import { Link, useNavigate } from "react-router-dom";
import { Slide, ToastContainer, toast } from "react-toastify";
import { useCartWishlist } from "../../../app/CartWishlistContext";
import { urlPolicyPage } from "../../../utils/url.utils";

const AuthLoginPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { getCartWishlistCount } = useCartWishlist();
  const { mobile, loading } = useSelector((state) => state.auth || {});
  const [step, setStep] = useState(1);
  const [timer, setTimer] = useState(30);
  const [localMobile, setLocalMobile] = useState("");
  const [otp, setOtp] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [errors, setErrors] = useState({});
  const [loader, setLoader] = useState(false);
  const mobileRef = useRef(null);
  const otpRef = useRef(null);
  const loginstep = localStorage.getItem('loginstep');


  useEffect(() => {
    if (loginstep) {
      setStep(parseInt(loginstep));
    }
  }, [loginstep]);

  useEffect(() => {
    document.title = `Obsessions - Sign In`;
    // Autofocus handling for each step
    if (step === 1 && mobileRef.current) {
      mobileRef.current.focus();
    } else if (step === 2 && otpRef.current) {
      otpRef.current.focus();
    }
    const token = localStorage.getItem("token");
    if (token) {
      navigate("/")
    }
  }, [step]);


  useEffect(() => {
    if (step === 2 && timer > 0) {
      const interval = setInterval(() => setTimer((prev) => prev - 1), 1000);
      return () => clearInterval(interval);
    }
  }, [step, timer]);


  const isValidMobile = (number) => /^[0-9]{10}$/.test(number.trim());
  const isValidEmail = (email) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());

  const handleSendOtp = () => {
    if (!localMobile.trim()) {
      toast.error("Please Enter Phone Number.", {
        style: {
          borderRadius: "inherit",
          padding: "16px",
          color: "#713200",
        },
        iconTheme: {
          primary: "#713200",
          secondary: "#FFFAEE",
        },
        hideProgressBar: true,
        closeButton: true,
        icon: true,
      });
      return false;
    }
    if (!isValidMobile(localMobile)) {
      toast.error("Mobile number must be exactly 10 digits.", {
        style: {
          borderRadius: "inherit",
          padding: "16px",
          color: "#713200",
        },
        iconTheme: {
          primary: "#713200",
          secondary: "#FFFAEE",
        },
        hideProgressBar: true,
        closeButton: true,
        icon: true,
      });
      return false;
    }

    dispatch(sendOtp(localMobile)).then((res) => {
      if (res.meta.requestStatus === "fulfilled") {
        const { otp_requested_id, temp_id } = res.payload.data;
        localStorage.setItem("otp_requested_id", otp_requested_id);
        localStorage.setItem("temp_id", temp_id);
        setStep(2);
        localStorage.setItem('loginstep', 2);
        setTimer(30);
      } else if (res.payload?.notRegistered) {
        setStep(3);
      }
    });
  };

  const handleRegister = () => {
    const newErrors = {};

    if (!firstName.trim()) newErrors.firstName = "First name is required.";
    if (!lastName.trim()) newErrors.lastName = "Last name is required.";
    if (!email.trim()) newErrors.email = "Email is required.";
    else if (!isValidEmail(email)) newErrors.email = "Enter a valid email.";

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) return;

    dispatch(
      registerUser({
        first_name: firstName.trim(),
        last_name: lastName.trim(),
        email: email.trim(),
        mobile: localMobile.trim(),
      })
    ).then((res) => {
      if (res.meta.requestStatus === "fulfilled") {
        const { otp_requested_id, temp_id } = res.payload.data;
        localStorage.setItem("otp_requested_id", otp_requested_id);
        localStorage.setItem("temp_id", temp_id);
        localStorage.setItem('loginstep', 2);
        setStep(2);
        setTimer(30);
      }
    });
  };

  const handleVerifyOtp = () => {
    if (!otp.trim()) {
      toast.error("Please enter the OTP.", {
        style: {
          borderRadius: "inherit",
          padding: "16px",
          color: "#713200",
        },
        iconTheme: {
          primary: "#713200",
          secondary: "#FFFAEE",
        },
        hideProgressBar: true,
        closeButton: true,
        icon: true,
      });
      return false;
    }
    // ✅ Validate 6-digit number (only digits, exactly 6)
    if (!/^\d{6}$/.test(otp)) {
      toast.error("Please enter a valid 6-digit OTP.", {
        style: {
          borderRadius: "inherit",
          padding: "16px",
          color: "#713200",
        },
        iconTheme: {
          primary: "#713200",
          secondary: "#FFFAEE",
        },
        hideProgressBar: true,
        closeButton: true,
        icon: true,
      });
      return false;
    }
    const otp_requested_id = localStorage.getItem("otp_requested_id");
    const temp_id = localStorage.getItem("temp_id");
    if (!otp_requested_id || !temp_id) {
      toast.error("Missing OTP session data. Try resending OTP.", {
        style: {
          borderRadius: "inherit",
          padding: "16px",
          color: "#713200",
        },
        iconTheme: {
          primary: "#713200",
          secondary: "#FFFAEE",
        },
        hideProgressBar: true,
        closeButton: true,
        icon: true,
      });
      return false;
    }
    setLoader(true);
    dispatch(verifyOtp({ otp: otp.trim(), otp_requested_id, temp_id })).then(
      (res) => {
        if (res.meta.requestStatus === "fulfilled") {
          console.log(res?.payload?.addresses[0]?.name);
          if (res?.payload?.addresses.length > 0) {
            localStorage.setItem('pincode', res?.payload?.addresses[0]?.pincode);
          }
          if (res?.payload?.user) {
            localStorage.setItem('userName', res?.payload?.user?.first_name + ' ' + res?.payload?.user?.last_name);
          }
          getCartWishlistCount();
          // return false;
          // toast.success("Login successful!", {
          //   style: {
          //     borderRadius:"inherit",
          //     padding: "16px",
          //     color: "#713200",
          //   },
          //   iconTheme: {
          //     primary: "#713200",
          //     secondary: "#FFFAEE",
          //   },
          //   hideProgressBar: true,
          //   closeButton: true,
          //   icon: true,
          // });
          setTimeout(() => {
            localStorage.removeItem('otp_requested_id');
            localStorage.removeItem('temp_id');
            localStorage.removeItem('loginstep');
            navigate(-1);
          }, 2000);
        } else if (res.meta.requestStatus === "rejected") {
          setLoader(false)
          const message =
            res.message ||
            res.error?.data?.message ||
            "Failed to verify OTP.";

          toast.error(message, {
            style: {
              borderRadius: "inherit",
              padding: "16px",
              color: "#713200",
            },
            iconTheme: {
              primary: "#713200",
              secondary: "#FFFAEE",
            },
            hideProgressBar: true,
            closeButton: true,
            icon: true,
          });
        }
      }
    );
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      if (step === 1) handleSendOtp();
      else if (step === 2) handleVerifyOtp();
      else if (step === 3) handleRegister();
    }
  };

  return (
    <>
      <ToastContainer style={{ zIndex: 9999999999999 }} position="top-right" autoClose={3000} limit={1} hideProgressBar={true} transition={Slide} newestOnTop={true} />
      <div className="login-container">
        <div className="login-box" onKeyDown={handleKeyDown}>
          {step === 1 && (
            <>
              <div className="title_track">
                <h2>Sign In</h2>
              </div>
              <input
                ref={mobileRef}
                type="text"
                className="phone_number"
                placeholder="Phone Number"
                inputMode="numeric"
                value={localMobile}
                onChange={(e) =>
                  setLocalMobile(e.target.value.replace(/\D/g, ""))
                }
                maxLength={10}
              />
              <button className="btn-dark button_track" onClick={handleSendOtp}>
                {loading ? "Sending..." : "CONTINUE"}
              </button>
              <p className="terms-track">
                <span style={{ color: '#625E55' }}> By continuing, you agree to Obsessions </span>  {" "}
                <Link to={urlPolicyPage('tc-of-sale')} target="_blank"><u style={{ color: '#1B170E' }}>Terms of Service</u></Link> <span style={{ color: '#625E55' }}>and{" "} </span>
                <Link to={urlPolicyPage(`privacy-policy`)} target="_blank"><u style={{ color: '#1B170E' }}>Privacy Policy</u></Link>
              </p>
            </>
          )}

          {step === 2 && (
            <>
              <div className="title_track">
                <h2>Verification Code</h2>
              </div>
              <p>
                A verification code has been sent to <span>{mobile || localMobile}</span>{" "}
                <span className="tracker_port pointer-crusser" onClick={() => { setStep(1); localStorage.setItem('loginstep', 1) }}>
                  <u>Change</u>
                </span>
              </p>
              <input
                ref={otpRef}
                type="text"
                placeholder="Verification Code"
                value={otp}
                max={6}
                inputMode="numeric"
                onChange={(e) => setOtp(e.target.value)}
              />
              <button className="btn-dark" onClick={handleVerifyOtp}>
                {/* VERIFY */}
                {loader ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>{" "}
                    Verifying...
                  </>
                ) : (
                  "VERIFY"
                )}
              </button>
              <p className="timer">
                Didn't receive code?{" "}
                {timer > 0 ? (
                  <span>00:{timer.toString().padStart(2, "0")}</span>
                ) : (
                  <span onClick={handleSendOtp} className="pointer-crusser">
                    <u>Resend OTP</u>
                  </span>
                )}
              </p>
            </>
          )}

          {step === 3 && (
            <>
              <div className="title_track">
                <h2>Let's Get Started</h2>
              </div>
              <input
                type="text"
                placeholder="First Name"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
              />
              {errors.firstName && (
                <p className="txt-ssg">{errors.firstName}</p>
              )}

              <input
                type="text"
                placeholder="Last Name"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
              />
              {errors.lastName && (
                <p className="txt-ssg">{errors.lastName}</p>
              )}

              <input
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              {errors.email && <p className="txt-ssg">{errors.email}</p>}

              <input type="text" disabled value={mobile || localMobile} />
              <button className="btn-dark" onClick={handleRegister}>
                CONTINUE
              </button>

              <div
                className="tracker_port2 pointer-crusser"
                onClick={() => {
                  setStep(1);
                  localStorage.setItem("loginstep", 1);
                }}
              >
                <p>Change Phone Number</p>
              </div>
            </>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default AuthLoginPage;
